export const getPaginationText = (currentPageIndex: number, pageSize: number, totalRows: number) => {
    const _pageSize = Math.max(pageSize, 5);
    const _currentPageIndex = Math.max(currentPageIndex, 0);

    //1. set total rows
    const _totalRowCount = totalRows;

    //2. figure out current row, reset if exceeds total
    let _currentRow = (_currentPageIndex * _pageSize) + 1;
    if (_currentRow > totalRows) _currentRow = 1;

    //3. figure out the last row
    let _lastRow = Math.min(
      (_currentPageIndex + 1) * _pageSize,
      _totalRowCount
    );

    return `Showing ${_currentRow} to ${_lastRow} of ${_totalRowCount} entries`
  }